import { Button } from '@/components/ui/button';
import { Calendar } from '@/components/ui/calendar';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Popover, PopoverContent, PopoverTrigger } from '@/components/ui/popover';
import { cn } from '@/lib/utils';
import { format } from 'date-fns';
import { CalendarIcon } from 'lucide-react';
import React from 'react';

const PTPRInspectionFields = ({ findings, setFindings }) => {
   // Handle input changes for PTPR specific fields
   const handleInputChange = (field, value) => {
      if (field === 'totalLotArea' || field === 'areaDevotedToPlantation') {
         value = parseFloat(value) || 0;
      }
      if (field === 'datePlanted' && value) {
         // No need to convert to Date object, just store as string
         value = value.trim();
      }

      setFindings(prev => ({
         ...prev,
         ptprFindings: {
            ...prev.ptprFindings || {},
            [field]: value
         }
      }));
   };

   return (
      <div className="space-y-6">
         <div>
            <Label className="text-base font-semibold">Tree Plantation Location Details</Label>
            <div className="grid grid-cols-2 gap-4 mt-4">
               <div className="space-y-2">
                  <Label>OCT/TCT No.</Label>
                  <Input
                     value={findings?.ptprFindings?.octTctNumber || ''}
                     onChange={(e) => handleInputChange('octTctNumber', e.target.value)}
                     placeholder="e.g., Transfer Certificate of Title No. 061-201900398"
                  />
               </div>

               <div className="space-y-2">
                  <Label>Lot Number</Label>
                  <Input
                     value={findings?.ptprFindings?.lotNumber || ''}
                     onChange={(e) => handleInputChange('lotNumber', e.target.value)}
                     placeholder="e.g., Lot No.5049, Cad. 544-D C-18"
                  />
               </div>

               <div className="space-y-2">
                  <Label>Barangay/s</Label>
                  <Input
                     value={findings?.ptprFindings?.barangay || ''}
                     onChange={(e) => handleInputChange('barangay', e.target.value)}
                     placeholder="Enter barangay"
                  />
               </div>

               <div className="space-y-2">
                  <Label>Municipality/ies</Label>
                  <Input
                     value={findings?.ptprFindings?.municipality || ''}
                     onChange={(e) => handleInputChange('municipality', e.target.value)}
                     placeholder="Enter municipality"
                  />
               </div>

               <div className="space-y-2">
                  <Label>Province</Label>
                  <Input
                     value={findings?.ptprFindings?.province || ''}
                     onChange={(e) => handleInputChange('province', e.target.value)}
                     placeholder="Enter province"
                  />
               </div>

               <div className="space-y-2">
                  <Label>Total Lot Area (hectares)</Label>
                  <Input
                     type="number"
                     step="0.0001"
                     value={findings?.ptprFindings?.totalLotArea || ''}
                     onChange={(e) => handleInputChange('totalLotArea', parseFloat(e.target.value) || 0)}
                     placeholder="e.g., 0.2374"
                  />
               </div>

               <div className="space-y-2">
                  <Label>Total Lot Area Devoted to Plantation (hectares)</Label>
                  <Input
                     type="number"
                     step="0.0001"
                     value={findings?.ptprFindings?.areaDevotedToPlantation || ''}
                     onChange={(e) => handleInputChange('areaDevotedToPlantation', parseFloat(e.target.value) || 0)}
                     placeholder="e.g., 0.2374"
                  />
               </div>

               <div className="space-y-2">
                  <Label>Spacing</Label>
                  <Input
                     value={findings?.ptprFindings?.spacing || ''}
                     onChange={(e) => handleInputChange('spacing', e.target.value)}
                     placeholder="e.g., 2-meter spacing"
                  />
               </div>

               <div className="space-y-2">
                  <Label>Tree Species Planted</Label>
                  <Input
                     value={findings?.ptprFindings?.treeSpeciesPlanted || ''}
                     onChange={(e) => handleInputChange('treeSpeciesPlanted', e.target.value)}
                     placeholder="e.g., 67- Mahogany (Swietenia macrophylla)"
                  />
               </div>

               <div className="space-y-2">
                  <Label>Date Planted</Label>
                  <Input
                     value={findings?.ptprFindings?.datePlanted || ''}
                     onChange={(e) => handleInputChange('datePlanted', e.target.value)}
                     placeholder="e.g., 2024"
                  />
               </div>
            </div>
         </div>
      </div>
   );
};

export default PTPRInspectionFields;